import { Button } from "components"
import ModalBS from "react-awesome-modal"
import React from "react"
import styles from "./Modal.module.scss"

const Modal = ({ visible, onClick, ...props }) => (
  <ModalBS
    visible={visible}
    className={styles.modal}
    effect="fadeInDown"
    onClickAway={onClick}
  >
    <div className={styles.wrapper}>
      <h2>Sommer Öffnungszeiten</h2>
      <p>
        <strong>Liebe Kunden,</strong>
        <br />
        <br />
        in den Wochen vom <strong>11.08.2025</strong> bis zum <br />
        <strong>30.08.2025</strong> gelten folgende Öffnungszeiten:
        <br />
        <br />
        Mo - Fr: 08:00 Uhr - 13:00 Uhr
        <br />
        <strong>Nachmittags geschlossen!</strong>
        <br />
        Sa: 07:30 Uhr - 13:00 Uhr
        <br />
        <br />
        vielen Dank für Ihr Verständnis!
        <br />
        <br />
      </p>
      <Button size="large" onClick={onClick}>
        Okay
      </Button>
    </div>
  </ModalBS>
)

export { Modal as default }
